import React from "react";
import { ShieldCheckIcon } from "@heroicons/react/outline";

const FallbackTab = ({ rateConfig, setRateConfig, updateFallbackOrder }) => {
  const handleMoveUp = (index) => {
    if (index > 0) {
      const newOrder = [...rateConfig.fallbackConfig.fallbackOrder];
      [newOrder[index - 1], newOrder[index]] = [newOrder[index], newOrder[index - 1]];
      updateFallbackOrder(newOrder);
    }
  };

  const handleMoveDown = (index) => {
    if (index < rateConfig.fallbackConfig.fallbackOrder.length - 1) {
      const newOrder = [...rateConfig.fallbackConfig.fallbackOrder];
      [newOrder[index], newOrder[index + 1]] = [newOrder[index + 1], newOrder[index]];
      updateFallbackOrder(newOrder);
    }
  };

  const getFallbackLabel = (item) => {
    switch(item) {
      case "MAIN": return "Main Branch";
      case "PARENT": return "Parent Branch";
      case "LIVE": return "Live Market";
      default: return item;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-3 flex items-center">
          <ShieldCheckIcon className="h-5 w-5 mr-2" />
          Fallback Configuration
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Configure fallback behavior when rates are unavailable
        </p>

        {/* Fallback Options */}
        <div className="bg-amber-50 p-4 rounded-lg mb-6">
          <h4 className="font-medium mb-3">Fallback Options</h4>
          <div className="space-y-3">
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={rateConfig.fallbackConfig.fallbackToMain}
                onChange={(e) =>
                  setRateConfig((prev) => ({
                    ...prev,
                    fallbackConfig: {
                      ...prev.fallbackConfig,
                      fallbackToMain: e.target.checked,
                    },
                  }))
                }
                className="h-4 w-4 text-amber-600 rounded mr-3"
              />
              <div>
                <span className="font-medium">Fallback to Main Branch</span>
                <p className="text-sm text-gray-600">
                  Use main branch rates when current branch rates are unavailable
                </p>
              </div>
            </label>

            <label className="flex items-center">
              <input
                type="checkbox"
                checked={rateConfig.fallbackConfig.fallbackToLive}
                onChange={(e) =>
                  setRateConfig((prev) => ({
                    ...prev,
                    fallbackConfig: {
                      ...prev.fallbackConfig,
                      fallbackToLive: e.target.checked,
                    },
                  }))
                }
                className="h-4 w-4 text-amber-600 rounded mr-3"
              />
              <div>
                <span className="font-medium">Fallback to Live Rates</span>
                <p className="text-sm text-gray-600">
                  Use live market rates as last resort
                </p>
              </div>
            </label>
          </div>
        </div>

        {/* Fallback Order */}
        <div className="bg-gray-50 p-4 rounded-lg">
          <h4 className="font-medium mb-3">Fallback Priority Order</h4>
          <div className="space-y-2">
            {rateConfig.fallbackConfig.fallbackOrder.map((item, index) => (
              <div
                key={item}
                className="flex items-center justify-between bg-white p-3 rounded border"
              >
                <div className="flex items-center">
                  <span className="font-medium text-gray-500 mr-3">
                    {index + 1}.
                  </span>
                  <span className="font-medium">{getFallbackLabel(item)}</span>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => handleMoveUp(index)}
                    disabled={index === 0}
                    className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => handleMoveDown(index)}
                    disabled={index === rateConfig.fallbackConfig.fallbackOrder.length - 1}
                    className="px-2 py-1 text-sm bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"
                  >
                    ↓
                  </button>
                </div>
              </div>
            ))}
          </div>
          <p className="text-xs text-gray-500 mt-3">
            System will check rates in this order and use the first available
          </p>
        </div>
      </div>
    </div>
  );
};

export default FallbackTab;
